import {
  Component, OnInit, ViewChild, OnDestroy,
  ElementRef, AfterViewInit, ChangeDetectorRef, HostListener
} from "@angular/core";
import { ROUTES } from './vertical-menu-routes.config';
import { HROUTES } from '../horizontal-menu/navigation-routes.config';

import { NavigationEnd, Router, Params } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { customAnimations } from "../animations/custom-animations";
import { DeviceDetectorService } from 'ngx-device-detector';
import { ConfigService } from '../services/config.service';
import { Subscription } from 'rxjs';
import { LayoutService } from '../services/layout.service';
import { AuthService } from "../auth/auth.service";
import { NavigationService } from "../services/navigation.service";
import { filter } from 'rxjs/operators';

@Component({
  selector: "app-sidebar",
  templateUrl: "./vertical-menu.component.html",
  animations: customAnimations
})
export class VerticalMenuComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('toggleIcon') toggleIcon: ElementRef;
  public menuItems: any[];
  level = 0;
  logoUrl = 'assets/img/logo.png';
  public config: any = {};
  protected innerWidth: any;
  layoutSub: Subscription;
  configSub: Subscription;
  perfectScrollbarEnable = true;
  collapseSidebar = false;
  resizeTimeout;
  claseToggle = '';
  private navigationTargetCache = new Map<string, { path: string; queryParams: Params | null; comparablePath: string }>();
  currentUrl: string = '';

  constructor(
    public authService: AuthService,
    private router: Router,
    public translate: TranslateService,
    private layoutService: LayoutService,
    private configService: ConfigService,
    private cdr: ChangeDetectorRef,
    private deviceService: DeviceDetectorService,
    private navigationService: NavigationService
  ) {
    this.config = this.configService.templateConf;
    this.innerWidth = window.innerWidth;
    this.isTouchDevice();
  }


  ngOnInit() {
    // Suscribirse a los cambios de navegación
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.currentUrl = event.urlAfterRedirects;
      this.checkActiveMenuItems();
    });

    // Cargar items del menú
    this.loadMenuItems();
  }

  loadMenuItems() {
    if (this.authService.usuarioConectado?.MenuItems) {
      this.menuItems = this.authService.usuarioConectado.MenuItems;
      this.navigationService.refreshMenuItems(); // Actualizar servicio de navegación
    }
  }

  checkActiveMenuItems() {
    // Aquí puedes agregar lógica para marcar items activos
    //console.log('URL actual en menú:', this.currentUrl);

    // Ejemplo: encontrar el título del menú para la URL actual
    const menuTitle = this.navigationService.getMenuTitleByUrl(this.currentUrl);
    //console.log('Título del menú actual:', menuTitle);

    // Ejemplo: obtener breadcrumb
    const breadcrumb = this.navigationService.getBreadcrumb(this.currentUrl);
    //console.log('Breadcrumb:', breadcrumb);
  }

  ngAfterViewInit() {
    this.configSub = this.configService.templateConf$.subscribe((templateConf) => {
      if (templateConf) {
        this.config = templateConf;
      }
      this.loadLayout();
      this.cdr.markForCheck();
    });

    this.layoutSub = this.layoutService.overlaySidebarToggle$.subscribe(
      collapse => {
        if (this.config.layout.menuPosition === 'Side') {
          this.collapseSidebar = collapse;
        }
      });

    this.claseToggle = this.config.layout.sidebar.collapsed ? 'fas fa-toggle-on' : 'fas fa-toggle-off';
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(event) {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    this.resizeTimeout = setTimeout((() => {
      this.innerWidth = event.target.innerWidth;
      this.loadLayout();
    }).bind(this), 500);
  }

  loadLayout() {
    if (this.config.layout.menuPosition === 'Top') { // Horizontal Menu
      if (this.innerWidth < 1200) { // Screen size < 1200
        // Aquí deberías cargar HROUTES si es necesario
        // this.menuItems = HROUTES;
      }
    } else if (this.config.layout.menuPosition === 'Side') { // Vertical Menu{
      this.loadMenuItems(); // Recargar items del menú
    }

    if (this.config.layout.sidebar.backgroundColor === 'white') {
      this.logoUrl = 'assets/img/logo-dark.png';
    } else {
      this.logoUrl = 'assets/img/logo.png';
    }

    if (this.config.layout.sidebar.collapsed) {
      this.collapseSidebar = true;
    } else {
      this.collapseSidebar = false;
    }
  }

  toggleSidebar() {
    const conf = this.config;
    conf.layout.sidebar.collapsed = !this.config.layout.sidebar.collapsed;
    this.configService.applyTemplateConfigChange({ layout: conf.layout });

    this.claseToggle = this.config.layout.sidebar.collapsed ? 'fas fa-toggle-on' : 'fas fa-toggle-off';

    setTimeout(() => {
      this.fireRefreshEventOnWindow();
    }, 300);
  }

  fireRefreshEventOnWindow = function () {
    const evt = document.createEvent('HTMLEvents');
    evt.initEvent('resize', true, false);
    window.dispatchEvent(evt);
  };

  CloseSidebar() {
    this.layoutService.toggleSidebarSmallScreen(false);
  }

  isTouchDevice() {
    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();

    if (isMobile || isTablet) {
      this.perfectScrollbarEnable = false;
    } else {
      this.perfectScrollbarEnable = true;
    }
  }

  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
    if (this.configSub) {
      this.configSub.unsubscribe();
    }
  }

  getInternalRoutePath(path: string): string {
    return this.getNavigationTarget(path).path;
  }

  getInternalQueryParams(path: string): Params | null {
    return this.getNavigationTarget(path).queryParams;
  }

  getComparablePath(path: string): string {
    return this.getNavigationTarget(path).comparablePath;
  }

  private getNavigationTarget(rawPath: string): { path: string; queryParams: Params | null; comparablePath: string } {
    const cacheKey = rawPath || '';
    const cached = this.navigationTargetCache.get(cacheKey);

    if (cached) {
      return cached;
    }

    const trimmedPath = (rawPath || '').trim();

    if (trimmedPath === '') {
      const emptyTarget = { path: '', queryParams: null, comparablePath: '' };
      this.navigationTargetCache.set(cacheKey, emptyTarget);
      return emptyTarget;
    }

    const questionMarkIndex = trimmedPath.indexOf('?');
    const rawInternalPath = questionMarkIndex >= 0 ? trimmedPath.substring(0, questionMarkIndex) : trimmedPath;
    const rawQueryString = questionMarkIndex >= 0 ? trimmedPath.substring(questionMarkIndex + 1) : '';
    const normalizedPath = rawInternalPath.startsWith('/') ? rawInternalPath : `/${rawInternalPath}`;
    const queryParams = this.parseQueryParams(rawQueryString);
    const comparablePath = queryParams
      ? `${normalizedPath}?${this.serializeQueryParams(queryParams)}`
      : normalizedPath;

    const target = { path: normalizedPath, queryParams, comparablePath };
    this.navigationTargetCache.set(cacheKey, target);

    return target;
  }

  private parseQueryParams(queryString: string): Params | null {
    if (!queryString) {
      return null;
    }

    const params: Params = {};
    const parsedQuery = new URLSearchParams(queryString);

    parsedQuery.forEach((value, key) => {
      const currentValue = params[key];

      if (currentValue === undefined) {
        params[key] = value;
      } else if (Array.isArray(currentValue)) {
        currentValue.push(value);
      } else {
        params[key] = [currentValue, value];
      }
    });

    return Object.keys(params).length > 0 ? params : null;
  }

  private serializeQueryParams(params: Params): string {
    const query = new URLSearchParams();

    Object.keys(params).forEach((key) => {
      const value = params[key];

      if (Array.isArray(value)) {
        value.forEach(v => query.append(key, `${v}`));
      } else if (value !== undefined && value !== null) {
        query.append(key, `${value}`);
      }
    });

    return query.toString();
  }

  // Método útil para verificar si un item del menú debe estar activo
  isMenuItemActive(path: string): boolean {
    return this.currentUrl === path;
  }

  // Método para verificar si algún hijo está activo (para items con submenu)
  hasActiveChild(item: any): boolean {
    if (!item.submenu || item.submenu.length === 0) return false;

    return item.submenu.some(sub => {
      if (sub.path === this.currentUrl) return true;
      if (sub.submenu) {
        return sub.submenu.some(deep => deep.path === this.currentUrl);
      }
      return false;
    });
  }

}
